import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../Api.js";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
// import "../Styles/ProfileActivityUpcoming.css"; 

function ProfileActivityUpcoming() {
  const [upcomingActivities, setUpcomingActivities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3; // 👈 cards per page
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchUpcomingActivities = async () => {
      const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        console.error("No access token found");
        navigate("/login");
        return;
      }
      try {
        const response = await Api.get("/activities/bookings/paid", {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        console.log("Upcoming activities data:", response.data.data);
        setUpcomingActivities(response.data.data);
      } catch (error) {
        console.error("Error fetching upcoming activities:", error);
      }
    };
    fetchUpcomingActivities();
  }, [navigate]);

  // 🔹 Pagination logic
  const totalPages = Math.ceil(upcomingActivities.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = upcomingActivities.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: "smooth" });


  };
  // 🔹 PDF handler
// const handlepdf = (bookingId) => {
//   window.open(
//     `https://admintest.jayrajgroup.org/admin/activity-bookings/${bookingId}/invoice`,
//     "_blank"
//   );
// };
const handlepdf = async (bookingId, invoiceNo) => {
  try {
    const res = await fetch(
      `https://admintest.jayrajgroup.org/api/activities/bookings/${bookingId}/invoice`,
      {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: 'application/pdf',
        },
      }
    );

    if (!res.ok) {
      throw new Error(
        res.status === 404 ? 'Invoice not found' : 'Could not download invoice'
      );
    }

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `invoice-${invoiceNo || bookingId}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Invoice download error:', err);
    alert(err.message);
  }
};

  return (
    <div className="profileActivity_container">
      {upcomingActivities.length === 0 ? (
        <p>No upcoming activities available.</p>
      ) : (
        <>
          {/* 🔹 Activity Cards */}
          {currentItems.map((activity) => (
            <div className="tripCard_wrapper" key={activity.id}>
              <div className="tripCard_image">
                <img
                  src={activity?.activity?.image}
                  alt={activity?.activity?.name}
                />
              </div>
              <div className="tripCard_content">
                <h2 className="tripCard_title">{activity?.activity?.name}</h2>
                <p className="tripCard_date review_class">
                  {/* {activity?.activity?.description} */}

                                                          {activity?.activity?.description
                                            ?.replace(/&nbsp;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&ndash;/gi, " ")          // remove &nbsp;
                                            ?.replace(/&amp; /gi, " ")          // remove &nbsp;
                                            ?.replace(/<\/?p>/g, "\n")          // replace <p> with new line
                                            ?.replace(/<br\s*\/?>/gi, "\n")     // handle <br> tags
                                            ?.replace(/<[^>]+>/g, "")           // remove all other HTML tags
                                            // ?.replace(/\s+/g, " ")              
                                            ?.split("\n")
                                            ?.map(line => line.trim())
                                            ?.filter(line => line !== "")
                                            ?.map((line, i) => (
                                                <li key={i} style={{ marginBottom: "8px" }}>
                                                    {line}
                                                </li>
                                            ))}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "0" }}>
                  Destintion: {activity?.activity?.booked_destination?.name}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "0" }}>
                  Amount: ₹{activity?.total_amount}
                </p>
                <p className="tripCard_date" style={{ fontWeight: "600", margin: "4px" }}>
                  Seats: {activity?.seats}
                </p>
                <div className="tripCard_buttons">
                  <button className="tripCard_btnDetails" onClick={()=> handlepdf(activity.id)}><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M382-320 155-547l57-57 170 170 366-366 57 57-423 423ZM200-160v-80h560v80H200Z"/></svg> Invoice</button>
                  <button className="tripCard_btnCancel">Cancel</button>
                </div>
              </div>
            </div>
          ))}

          {/* 🔹 MUI Pagination (only arrows, no first/last buttons) */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 3,
              marginBottom: 3,
            }}
          >
            <Stack spacing={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                shape="rounded"
                siblingCount={1}
                boundaryCount={0}
              />
            </Stack>
          </Box>
        </>
      )}
    </div>
  );
}

export default ProfileActivityUpcoming;
